const en = {
  en: {
    messages: {
      required: (field) => {
        return field + ' is required.'
      }
    },
    attributes: {
      name: 'A name',
      client: 'A client name',
      title: 'Red flag title',
      project: 'A project name',
      organization: 'An organization name',
      invite: 'A valid invite code',
      role: 'A role',
      fullName: 'A name',
      currency: 'A currency symbol',
      currentFte: 'This',
      goalFte: 'This',
      currentBfte: 'This',
      goalBfte: 'This',
      goalWorkWeeks: 'This',
      goalBillableHours: 'This',
      currentClients: 'This',
      goalClients: 'This',
      goalClientsPerEmployee: 'This',
      taxRate: 'This',
      goalSalaryProportion: 'This',
      currentFullTimeEmployees: 'The number of current full-time employees',
      goalFullTimeEmployees: 'The number of full-time employees you want',
      currentBillableEmployees: 'The number of current billable full-time employees',
      goalBillableEmployees: 'The number of billable full-time employees you want',
      goalAverageBillableHours: 'The number of billable hours per week',
      currentAverageSalary: 'The current average salary',
      goalAverageSalary: 'The average salary you want',
      weeksOff: 'The amount weeks off per year',
      goalClientLoad: 'Your employee‘s ideal client load',
      currentRevenue: 'Your current annual revenue',
      currentExpenses: 'Your current annual expenses',
      taxes: 'The amount you pay in taxes each year (%)',
      activeClients: 'Your current number of active clients in one year',
      goalActiveClients: 'Your ideal number of active clients in one year'
    }
  }
}

export default en
